module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.b2bcaa52.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.ttf
// module id = 527
// module chunks = 0